import { Component } from '@angular/core';
import { CustomizationStoreService } from 'src/services/customization.store.service';

@Component({
  selector: 'belender-expiration-date',
  templateUrl: './expiration-date.component.html',
  styleUrls: ['./expiration-date.component.scss']
})
export class ExpirationDateComponent {
  funderStyles$;
  funderStyles;

  constructor(private customizationStoreService: CustomizationStoreService) {
    // set Customization data when CustomizationService request is completed
    this.funderStyles$ =
      this.customizationStoreService.funderStyles$.subscribe(
        (customization) => {
          if (Object.keys(customization).length > 0) {
            this.funderStyles = customization;
          }
        },
      );
  }
}
